<template>
  <div>
    <div class="d-flex justify-content-center mb-1">
      <b-spinner label="Loading..." style="width: 3rem; height: 3rem" />
    </div>
  </div>
</template>

<script>
import { BSpinner } from "bootstrap-vue";

export default {
  components: {
    BSpinner,
  },
};
</script>